<template>
  <div class="d-flex flex-column gap-6" data-testid="approval-list">
    <page-header 
      :title="$nova.labelsName('approvals_page', 'header_title', 'Approvals')" 
      @refresh="getRefreshData({reload:true})" 
    />
    <div class="d-flex justify-center">
      <lb-filter :filterheaders="filterOptionsData" :loading="filterLoading" ty :isFileGenarating = "isFileGenarating" @loadFilterData="getFilterData" @genarateFile="generateFile" @resetFilters="getFilterData({filter:{},reload:true})" />
    </div>
    <v-card class="pa-4 d-flex flex-column gap-3">
      <approval-status-cards
        :dataStatusCount="dataStatusCount"
        :activeFilter="activeStageFilter"
        :pendingCountDisplay="pendingCountDisplay"
        :approvedCountDisplay="approvedCountDisplay"
        :rejectedCountDisplay="rejectedCountDisplay"
        :failedCountDisplay="failedCountDisplay"
        :inProgressCountDisplay="inProgressCountDisplay"
        @filter="handleCardFilter"
      />
      <div v-if="formatteddata.length > 0" class="" data-testid="approval-list__table-container">
        <lb-datatablenew
          :headers="headers"
          :items="formatteddata"
          :filterheaders="filterOptionsData"
          :enableslot="['submitdate', 'submittername', 'typetext','approvedby','approvedon', 'action', 'stage']"
          :loading="(loading && filterLoading)"
          @loadFilterData="getRefreshData"
          data-testid="approval-list__table"
        >
          <template v-slot:typetext="{ item }">
            <span>{{item.typetext}}</span>
          </template>
          <template v-slot:submitdate="{ item }">
            <span>{{$nova.formatDateTime(item.submitdate)}}</span>
          </template>
          <template v-slot:submittername="{ item }">
            <div :class="{ 'text-center': !item.submitter_detail?.name && item.submitter_detail?.email }">
              <template v-if="item.submitter_detail?.name">
                <span>{{item.submitter_detail.name}}</span>
                <br />
              </template>
              <v-chip :class="item.submitter_detail?.email ? (item.submitter_detail.email.toLowerCase().includes('external') ? 'mailChipExternal' : 'mailChip') : 'mailChipEmpty'">
                <span class="textLowercase">{{item.submitter_detail?.email}}</span>
              </v-chip>
            </div>
          </template>
          <template v-slot:approvedby="{ item }">
            <div :class="{ 'text-center': !(item._resolvedByDetail || item.approver_detail)?.name && (item._resolvedByDetail || item.approver_detail)?.email }">
              <template v-if="(item._resolvedByDetail || item.approver_detail)?.name">
                <span>{{ (item._resolvedByDetail || item.approver_detail).name }}</span>
                <br />
              </template>
              <v-chip :class="(item._resolvedByDetail || item.approver_detail)?.email ? ((item._resolvedByDetail || item.approver_detail).email.toLowerCase().includes('external') ? 'mailChipExternal' : 'mailChip') : 'mailChipEmpty'">
                <span class="textLowercase">{{ (item._resolvedByDetail || item.approver_detail)?.email || "" }}</span>
              </v-chip>
            </div>
          </template>
          <template v-slot:approvedon="{ item }">
            <span>{{ $nova.formatDateTime(item._resolvedOnDate || item.approvedate) || "" }}</span>
          </template>
          <template v-slot:stage="{ item }">
            <status-indicator
              :variant="getStageVariant(item.stage)"
              :custom-label="item.stage"
              size="sm"
            />
          </template>
          <template v-slot:action="{ item }">
            <v-tooltip bottom content-class="tooltip-bottom">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" color="" @click="getDetails(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>
        </lb-datatablenew>
      </div>
      <div v-else-if="loading" class="pa-4">
        <v-skeleton-loader type="table-heading, table-row@5"></v-skeleton-loader>
      </div>
      <div v-else class="title grey--text pa-5 text-center">
        No Data Found
      </div>
      
      <!-- Pagination always at the bottom of the card, visible if data exists -->
      <div v-if="(formatteddata.length > 0 || totalItems > 0) && totalPages > 0" class="">
        <!-- Pagination Debug: totalPages={{ totalPages }}, totalItems={{ totalItems }}, page={{ page }}, pageSize={{ pageSize }} -->
        <Pagination
          v-model="page"
          :length-override="totalPages"
          :hide-on-single-page="false"
          :server-mode="true"
          :itemsperpage="pageSize"
          @input="handlePaginationPageChange"
          data-testid="approval-list__pagination"
        />
      </div>
    </v-card>

    <approval-details-dialog
      v-if="viewdialog"
      v-model="viewdialog"
      :viewdata="viewdata"
      :viewloading="viewloading"
      :total_cycle="total_cycle"
      :proccesed_cycle="proccesed_cycle"
      :proccesed_Ru="proccesed_Ru"
      :materialityTypes="materialityTypes"
      :errorReportAvailable="errorReportAvailable"
      :gldata="gldata"
      :materialityDetailsPage.sync="materialityDetailsPage"
      :display="display"
      @download-failed="downloadExcelFailedData"
      @refresh="getDetails"
      @reject="rejectItem"
      @retry="approveItem"
      @approve="approveItem"
    />

  </div>
</template>
<script>
import ApprovalStatusCards from './ApprovalStatusCards.vue';
import ApprovalDetailsDialog from './ApprovalDetailsDialog.vue';
import PageHeader from '../../../components/PageHeader.vue';
import StatusIndicator from '../../../components/StatusIndicator.vue';
import Pagination from '@/views/common/Pagination.vue';
import { STATUS_VARIANTS } from '../../../utils/statusConstants';
import { FILTER_REQUEST_TYPES_ARRAY } from '../../../utils/constants'; 
import helpers from '../../../utils/helpers';
import { mapActions } from "vuex"; // Added mapActions

let styledxlsx = require('sheetjs-style');
export default {
  name: 'approval_list',
  components: {
    ApprovalStatusCards,
    ApprovalDetailsDialog,
    PageHeader,
    StatusIndicator,
    Pagination
  },
  data: function(){
    return {
      pagename:"approvals_page",
      loading:false,
      viewloading: false,
      viewdialog: false,
      viewdata: {},
      gldata: {},
      type: "",
      requestdata: {},
      colors: {},
      formatteddata: [],
      selecteditem: "",
      headers: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
          alignment: "text-center"
        },
        {
          value: "moduletext",
          text: "Module Type",
          sortable: false,
          filterable: false,
        },
        {
          value: "typetext",
          text: "Request Type",
          sortable: false,
          filterable: false,
          datatype: "string",
          lock: true,
          visible: false,
        },
        {
          type: "string",
          value: "submittername",
          text: this.$nova.labelsName('approvals_page','commentary_submitted_by_label','Submitted By'),
          sortable: false,
          filterable: false,
          // lock: true,
        },
        {
          type: "date",
          value: "submitdate",
          text: this.$nova.labelsName('approvals_page','commentary_submitted_on_label','Submitted On'),
          sortable: true,
          defaultsort: 'desc'
          // lock: true,
        },
        {
          type: "string",
          value: "approvedby",
          text: this.$nova.labelsName('approvals_page','commentary_resolved_by_label','Resolved By'),
          sortable: false,
          filterable: false,
        },
        {
          type: "string",
          value: "approvedon",
          text:this.$nova.labelsName('approvals_page','commentary_resolved_on_label','Resolved On'),
          sortable: true,
        },
        {
          type: "string",
          value: "stage",
          text: "Status",
          sortable: false,
          filterable: false,
          // lock: true,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          // lock: true,
        }
      ],
      dataStatusCount:{"open":-1,'approved':-1,'rejected':-1,'inProgress':-1,'retry':-1},
      reportingunit:'',
      total_cycle:[],
      proccesed_cycle:[],
      proccesed_Ru: [],
      page:1,
      filterOptionsData: [],
      previousFilter: {},
      filterLoading: true,
      meta:this.metaData || {},
      isFileGenarating : false,
      materialityDetailsPage:0,
      materialityTypes:this.$constants.MATERIALITYTYPES,
      errorReportAvailable:false,
      pageSize: 25,
      totalItems: 0,
      globalTotalItems: 0,
      activeStageFilter: null, // Track which stage is currently filtered
    } 
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    metaData:{
      type:Object,
      default: () => {}
    },
    display: {
      type: String,
      default: "view",
    },
    customHeaders: {
      type: Array,
      default: ()=> [],
    },
    pendingCountDisplay: {
      type: Boolean,
      default: true
    },
    approvedCountDisplay: {
      type: Boolean,
      default: true
    },
    rejectedCountDisplay: {
      type: Boolean,
      default: true
    },
    failedCountDisplay: {
      type: Boolean,
      default: true
    },
    inProgressCountDisplay: {
      type: Boolean,
      default: true
    },
    filterData:{
      type: [Object, Array],
      default:()=>({})
    }
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    ...mapActions('varianceanalysis/approvals', ['fetchApprovalsListWithCounts', 'approveRequest', 'rejectRequest']),
    // Handles page change from Pagination (server mode: receives page number)
    /**
     * Handles page change from Pagination (server mode: receives page number)
     * Ensures correct page is set and triggers data fetch for that page.
     */
    async handlePaginationPageChange(page) {
      const safePage = Math.max(1, Number(page) || 1);
      if (this.page !== safePage) {
        this.page = safePage;
      }
      
      // Always force refresh on page change to avoid stale cached data
      await this.getData(safePage);
    },
    getStageVariant(stage) {
      const map = {
        'Open': STATUS_VARIANTS.LOCAL_AWAITED,
        'Approved': STATUS_VARIANTS.APPROVED,
        'Rejected': STATUS_VARIANTS.LOCAL_REJECTED,
        'In Progress': STATUS_VARIANTS.PENDING,
        'Failed': STATUS_VARIANTS.REGIONAL_REJECTED,
      };
      return map[stage] || STATUS_VARIANTS.UNKNOWN;
    },
    extractOptionList(source, keys) {
      if (!source) return [];
      for (const key of keys) {
        const candidate = source?.[key];
        if (Array.isArray(candidate) && candidate.length) {
          return candidate;
        }
      }
      return [];
    },
    createOptionsFromArray(list, valueKeys, nameKeys) {
      const unique = new Map();
      (list || []).forEach((item) => {
        if (item === null || typeof item === 'undefined') {
          return;
        }
        if (typeof item === 'string' || typeof item === 'number') {
          const scalar = String(item);
          if (!unique.has(scalar)) {
            unique.set(scalar, { _id: scalar, name: scalar });
          }
          return;
        }
        const value = valueKeys.reduce((acc, key) => acc || item?.[key], null);
        const label = nameKeys.reduce((acc, key) => acc || item?.[key], null);
        if (value || label) {
          const resolvedValue = value || label || '';
          const resolvedLabel = label || value || '';
          if (!unique.has(resolvedValue)) {
            unique.set(resolvedValue, {
              _id: resolvedValue,
              name: resolvedLabel,
            });
          }
        }
      });
      return Array.from(unique.values());
    },
    deriveRequestTypeFallbacks() {
      const sourceList = Array.isArray(this.formatteddata) && this.formatteddata.length
        ? this.formatteddata
        : Array.isArray(this.data) && this.data.length
          ? this.data
          : [];
      const transformed = sourceList.map((entry) => ({
        type: entry?.type || entry?.request_type || entry?.code,
        code: entry?.typetext || entry?.type || entry?.request_type || entry?.code,
      }));
      return this.createOptionsFromArray(
        transformed,
        ['_id', 'id', 'type', 'code'],
        ['name', 'code', 'typetext']
      );
    },
    prepareFilterOptions(filterSource = this.filterData || {}) {
      // const statusOptions = [
      //   { status: "Open", _id: 0 },
      //   { status: "Approved", _id: 1 },
      //   { status: "Rejected", _id: -1 },
      //   { status: "In Progress", _id: 2 },
      //   { status: "Failed", _id: 3 }
      // ];

      const rawTypeList = this.extractOptionList(filterSource, [
        'type',
        'types',
        'possibletypes',
        'possible_types',
        'requestTypes',
        'request_types',
      ]);

      let requestTypeOptions = this.createOptionsFromArray(
        rawTypeList,
        ['_id', 'id', 'type', 'code', 'value'],
        ['name', 'code', 'label', 'description', 'displayname', 'typetext']
      );

       // Ensure all standard request types are available in the filter and have correct naming from constants
      const optionMap = new Map(requestTypeOptions.map(o => [o._id, o]));
      (FILTER_REQUEST_TYPES_ARRAY || []).forEach(definedType => {
        if (definedType._id === 'all') return; 
        
        if (optionMap.has(definedType._id)) {
           // Update name to constant name for consistency
           const existing = optionMap.get(definedType._id);
           existing.name = definedType.name;
        } else {
           // Add missing type if not present
           const newOption = { ...definedType };
           requestTypeOptions.push(newOption);
           optionMap.set(definedType._id, newOption);
        }
      });

      if (!requestTypeOptions.length) {
        requestTypeOptions = this.deriveRequestTypeFallbacks();
      }

      const normalizeDisplayName = (item) => {
        if (!item) return item;
        const name = (item.name || '').trim();
        const email = item.email || '';
        if (!name && email) {
          return { ...item, displayname: email };
        }
        return item;
      };

      const submitterOptions = Array.isArray(filterSource?.submitter_detail)
        ? filterSource.submitter_detail.map(normalizeDisplayName)
        : [];

      const approverOptions = Array.isArray(filterSource?.approver_detail)
        ? filterSource.approver_detail.map(normalizeDisplayName)
        : [];

      const moduleOptions = [
        { name: "Balance Sheet", _id: "bs" }, 
        { name: "Profit & Loss", _id: "pl" }
      ];

      this.filterOptionsData = [
        {
          value: 'name',
          key: 'reporting_type',
          name: this.$nova.labelsName('approvals_page','module_label','Module'),
          data: moduleOptions,
        },
        {
          value: 'name',
          key: 'possibletypes',
          name: this.$nova.labelsName('approvals_page','commentary_request_type_label','Request Type'),
          data: requestTypeOptions,
        },
        {
          value: 'displayname',
          key: 'submitter',
          data: submitterOptions,
          name: this.$nova.labelsName('approvals_page','commentary_submitted_by_label','Submitted By'),
        },
        {
          value: 'submittedon',
          key: 'submitdate',
          name: this.$nova.labelsName('approvals_page','commentary_submitted_on_label','Submitted On'),
          type: 'daterange',
          data: [],
        },
        {
          value: 'displayname',
          key: 'approver',
          data: approverOptions,
          name: this.$nova.labelsName('approvals_page','commentary_resolved_by_label','Resolved By'),
        },
        {
          value: 'resolvedon',
          key: 'approvedate',
          name: this.$nova.labelsName('approvals_page','commentary_resolved_on_label','Resolved On'),
          type: 'daterange',
          data: [],
        },
      ];

      this.filterLoading = false;
    },
    async refreshData() {
      if(this.display !== "view") this.headers.push();
      this.prepareFilterOptions();
      // Always fetch data from API with pagination
      this.page = 1;
      this.totalItems = 0;
      
      // Force refresh to ensure fresh data on page navigation
      await this.getData(1);
      
      if (this.customHeaders.length > 0) {
        this.headers = this.customHeaders;
      }
    },
    downloadExcelFailedData(id){
      try {
        this.$nova.downloadFile("", {},`/v2/varianceanalysis/approvals/getFailedMaterialityRecords/${id}`);
      } catch (err) {
        this.$store.commit("sbError", err.message || "Failed to download the Excel file.");
        console.error("Error in downloadExcelFailedData:", err);
      }
    },
    getDetails(item) {
      this.viewloading = true;
      this.viewdialog = true;
      this.materialityDetailsPage = 0;
      this.viewdata = {};
      this.selecteditem = item;
      let url = "/v2/varianceanalysis/approvals/getdetail/"
      if(item.type === 'glselectionchange'){
        url = "/v2/varianceanalysis/approvals/glselectiongetdetail/"
      }
      helpers.apiGet.call(this, url+item._id).then(dt => {
        if(dt.data.status === "success") {
          this.viewdata = dt.data.data || {};
          this.reportingunit= dt.data.data.reportingunit;
          this.total_cycle= dt.data?.data?.total_cycle || [];
          this.proccesed_cycle = dt.data?.data?.proccesed_cycles || [];
          this.proccesed_Ru = dt.data?.data?.proccesed_Ru || [];
          this.errorReportAvailable = dt.data?.data?.error_report_available || false;
          if(this.viewdata.userlist instanceof Array){
            let t = {};
            for (const i of this.viewdata.userlist) {
              t[i._id] = i;
            }
            this.viewdata.__userlist = t;
          }
          if(this.viewdata.reportingunit_detail instanceof Array){
            let t = {};
            for (const i of this.viewdata.reportingunit_detail) {
              t[i._id] = i;
            }
            this.viewdata.__reportingunit_detail = t;
          }
          if(this.viewdata.gllist instanceof Array){
            let t = {};
            for (const i of this.viewdata.gllist) {
              t[i._id] = i;
            }
            this.viewdata.__gllist = t;
          }
          if(this.viewdata.type === "materialityrulevel" || this.viewdata.type === "bulkmaterialityrulevel"){
            this.gldata = {"ru": this.formatGLData(this.viewdata.data[0]?.materiality || {})}
            this.updateStageById(this.formatteddata, dt.data.data._id ,dt.data.data.stage)
          }
          else if(this.viewdata.type === "filematerialityrulevel"){
            this.gldata = {}
            for (const i of (this.viewdata.data[0]?.materiality || [])) {
              this.gldata[i.rucode] = this.gldata[i.rucode] || {};
              if(i.actual) {
                this.gldata[i.rucode]["actual"] = this.gldata[i.rucode]["actual"] || [];
                this.gldata[i.rucode]["actual"].push({...(i.actual || {}), glcode: i.glcode, period:i?.period || '-'})
              }
              if(i.forecast) {
                this.gldata[i.rucode]["forecast"] = this.gldata[i.rucode]["forecast"] || [];
                this.gldata[i.rucode]["forecast"].push({...(i.forecast || {}), glcode: i.glcode,period:i?.period || '-'})
              }
            }
            for (const k in this.gldata) {
              if (Object.hasOwnProperty.call(this.gldata, k)) {
                const el = this.gldata[k];
                if(el.actual) el.actual = this.formatGLData(el.actual);
                if(el.forecast) el.forecast = this.formatGLData(el.forecast);
              }
            }
            this.updateStageById(this.formatteddata, dt.data.data._id, dt.data.data.stage);
          }
          else if(this.viewdata.type === "materialitygllevel" || this.viewdata.type === "bulkmaterialitygllevel" || this.viewdata.type === "materialitysllevel" || this.viewdata.type === "bulkmaterialitysllevel"){
            this.gldata = {"one": this.formatGLData(this.viewdata.data[0]?.materiality || [])}
            this.updateStageById(this.formatteddata, dt.data.data._id ,dt.data.data.stage)
          }
          else if(this.viewdata.type === "filematerialitygllevel" || this.viewdata.type === "filematerialitysllevel"){
            this.gldata = {}
            for (const i of (this.viewdata.data[0]?.materiality || [])) {
              this.gldata[i.rucode] = this.gldata[i.rucode] || {};
              for (const j of i.data || []) {
                if (j.actual) {
                  this.gldata[i.rucode]["actual"] = this.gldata[i.rucode]["actual"] || [];
                  this.gldata[i.rucode]["actual"].push({ ...(j.actual || {}), glcode: j.glcode,period:j?.period || '-' })
                } else console.log("no actual found");
                if (j.forecast) {
                  this.gldata[i.rucode]["forecast"] = this.gldata[i.rucode]["forecast"] || [];
                  this.gldata[i.rucode]["forecast"].push({ ...(j.forecast || {}), glcode: j.glcode,period:j?.period || '-' })
                } else console.log("no forecast found");
              }
            }
            for (const k in this.gldata) {
              if (Object.hasOwnProperty.call(this.gldata, k)) {
                const el = this.gldata[k];
                if(el.actual) el.actual = this.formatGLData(el.actual);
                if(el.forecast) el.forecast = this.formatGLData(el.forecast);
              }
            }
            this.updateStageById(this.formatteddata, dt.data.data._id, dt.data.data.stage);
          }
          else if(this.viewdata.data[0].type === 'glselectionchange'){
            this.viewdata = this.viewdata.data[0] || []
            if(typeof this.viewdata.data[0]?.gls_actual !== 'undefined'){
              this.viewdata.data[0].cycle = 'Actual'
            }else{
              this.viewdata.data[0].cycle = 'Forecast'
            }
          }
        }else throw new Error ("Error reading data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.viewloading = false;
      })
    },
    formatGLData(dt){
      let ndt = [];
      for (const i of dt) {
        ndt.push({
            code: this.viewdata.__gllist?.[i.glcode]?.code ?? "",
            name: this.viewdata.__gllist?.[i.glcode]?.name ?? "",
            control_thresholds_amount_proforma: i?.control_thresholds_amount_proforma ?? i?.control_thresholds_amount ?? '',
            control_thresholds_percent_proforma: i?.control_thresholds_percent_proforma ?? i?.control_thresholds_percent ?? '',
            // floor_control_thresholds_amount_proforma: i?.floor_control_thresholds_amount_proforma || 0,
            management_thresholds_amount_proforma: i?.management_thresholds_amount_proforma ?? i?.management_thresholds_amount ?? '',
            management_thresholds_percent_proforma: i?.management_thresholds_percent_proforma ?? i?.management_thresholds_percent ?? '',
            // floor_management_thresholds_amount_proforma: i?.floor_management_thresholds_amount_proforma || 0,
            control_thresholds_amount_regional_proforma: i?.control_thresholds_amount_regional_proforma ?? i?.control_thresholds_amount_regional ?? '',
            control_thresholds_percent_regional_proforma: i?.control_thresholds_percent_regional_proforma ?? i?.control_thresholds_percent_regional ?? '',
            // floor_control_thresholds_amount_regional_proforma: i?.floor_control_thresholds_amount_regional_proforma || '',
            management_thresholds_amount_regional_proforma: i?.management_thresholds_amount_regional_proforma ?? i?.management_thresholds_amount_regional ?? '',
            management_thresholds_percent_regional_proforma: i?.management_thresholds_percent_regional_proforma ?? i?.management_thresholds_percent_regional ?? '',
            // floor_management_thresholds_amount_regional_proforma: i?.floor_management_thresholds_amount_regional_proforma || '',
            control_thresholds_amount_forecast: i?.control_thresholds_amount_forecast ?? i?.control_thresholds_amount ?? '',
            control_thresholds_percent_forecast: i?.control_thresholds_percent_forecast ?? i?.control_thresholds_percent ?? '',
            // floor_control_thresholds_amount_forecast: i?.floor_control_thresholds_amount_forecast || '',
            management_thresholds_amount_forecast: i?.management_thresholds_amount_forecast ?? i?.management_thresholds_amount ?? '',
            management_thresholds_percent_forecast: i?.management_thresholds_percent_forecast ?? i?.management_thresholds_percent ?? '',
            // floor_management_thresholds_amount_forecast: i?.floor_management_thresholds_amount_forecast || '',
            control_thresholds_amount_regional_forecast: i?.control_thresholds_amount_regional_forecast ?? i?.control_thresholds_amount_regional ?? '',
            control_thresholds_percent_regional_forecast: i?.control_thresholds_percent_regional_forecast ?? i?.control_thresholds_percent_regional ?? '',
            // floor_control_thresholds_amount_regional_forecast: i?.floor_control_thresholds_amount_regional_forecast || '',
            management_thresholds_amount_regional_forecast: i?.management_thresholds_amount_regional_forecast ?? i?.management_thresholds_amount_regional ?? '',
            management_thresholds_percent_regional_forecast: i?.management_thresholds_percent_regional_forecast ?? i?.management_thresholds_percent_regional ?? '',
            period: i.period ?? '-'
            // floor_management_thresholds_amount_regional_forecast: i?.floor_management_thresholds_amount_regional_forecast || '',
          }
        )
      }
      return ndt;
    },
    async approveItem(item) {
      this.viewloading = true;
      const result = await this.approveRequest({
        id: item._id,
        type: item.type,
        axiosInstance: this.axios
      });

      if (result.success) {
          // Success msg handled in store
          this.requestdata = (result.data && result.data[0]) || {};
          if(this.viewdata.type =='materialityrulevel' || this.viewdata.type =='materialitygllevel' || this.viewdata.type =='bulkmaterialityrulevel' || this.viewdata.type =='filematerialityrulevel' || this.viewdata.type =='bulkmaterialitygllevel' || this.viewdata.type =='filematerialitygllevel' || this.viewdata.type =='materialitysllevel' || this.viewdata.type =='bulkmaterialitysllevel' || this.viewdata.type =='filematerialitysllevel')
          {
            this.updateStageById(this.formatteddata,item._id, 2);
          }
          else
          {
            this.updateStageById(this.formatteddata,item._id, 1);
          }
          this.viewdialog = false;
      } else {
        this.viewdata.stage = 3
        this.updateStageById(this.formatteddata,item._id, 3);
        // Error msg handled in store
      }
      this.viewloading = false;
    },
    async rejectItem(item) {
      this.viewloading = true;
      const result = await this.rejectRequest({
        id: item._id,
        type: item.type,
        axiosInstance: this.axios
      });

      if (result.success) {
          // Success msg handled in store
          this.requestdata = (result.data && result.data[0]) || {};
          item.stage = -1;
          this.selecteditem.stage = 'Rejected';
          this.updateStageById(this.formatteddata,item._id, -1);
          this.viewdialog = false;
      } else {
        this.viewdata.stage = 3
        this.updateStageById(this.formatteddata,item._id, 3);
        console.log(result.error);
        // Error msg handled in store
      }
      this.viewloading = false;
    },
    setColors(){
      this.colors = {};
      let colorlist = this.$nova.getColors(13, 0.2);
      this.colors["materialityrulevel"] = colorlist[0];
      this.colors["bulkmaterialityrulevel"] = colorlist[1];
      this.colors["materialitygllevel"] = colorlist[2];
      this.colors["bulkmaterialitygllevel"] = colorlist[3];
      this.colors["filematerialityrulevel"] = colorlist[4];
      this.colors["filematerialitygllevel"] = colorlist[5];
      this.colors["materialitysllevel"] = colorlist[6];
      this.colors["bulkmaterialitysllevel"] = colorlist[7];
      this.colors["filematerialitysllevel"] = colorlist[8];
      this.colors["glorder"] = colorlist[9];
      this.colors["accesschange"] = colorlist[10];
      this.colors["bulkaccesschange"] = colorlist[11];
      this.colors["fileaccesschange"] = colorlist[12];
      this.colors["glselectionchange"] = colorlist[13];
    },
    formatData: function(data){
      let ArrayTemp = [];
      const pageOffset = (this.page - 1) * this.pageSize; // Calculate offset based on current page
      data.forEach((i, k) => {
        i.__key = k;
        i.indexno = pageOffset + k + 1; // Correct serial number across pages
        
        let moduleText = "NA";
        if (i.reporting_type === 'bs') moduleText = "Balance Sheet";
        else if (i.reporting_type === 'pl') moduleText = "Profit & Loss";
        i.moduletext = moduleText;

        let stageName = "";
        // i.__click = this.getDetails;
        if (i.stage === 0 || i.stage === "Open") {
          stageName = "Open"
          // this.dataStatusCount.open++
        }
        else if(i.stage === 1 || i.stage === "Approved"){
          stageName ="Approved"
          // this.dataStatusCount.approved++
        }
        else if(i.stage === -1 || i.stage === "Rejected"){
          stageName = "Rejected"
          // this.dataStatusCount.rejected++
        }
        else if(i.stage === 2 || i.stage === "inProgress" || i.stage === "In Progress" || i.stage === "inprogress"){
          stageName = "In Progress"
          // this.dataStatusCount.open++
        }
        else if(i.stage === 3 || i.stage === "Retry" || i.stage === "Failed" || i.stage === "failed"){
          stageName = "Failed"
          // this.dataStatusCount.retry++
        }
        i.stage = stageName;
        i.submittername= i.submitter_detail?.displayname || ""
        // For Failed (stage 3) records, fall back to updated_detail if approver_detail is missing
        i._resolvedByDetail = (stageName === 'Failed' && !i.approver_detail && i.updated_detail)
          ? i.updated_detail
          : i.approver_detail || null;
        i.approvedby = i._resolvedByDetail?.displayname || ""
        i._resolvedOnDate = (stageName === 'Failed' && !i.approvedate && i.updated_at)
          ? i.updated_at
          : i.approvedate || "";
        i.approvedon = i._resolvedOnDate;
        i.stageName = stageName;
        ArrayTemp.push(i);
      });
      this.setColors();
      return ArrayTemp;
    },
    updateStageById: function(data, id, newStage) {
      this.formatteddata = data.map(item =>
        item._id === id ? { ...item, stage: newStage} : item
      );
      this.formatData(this.formatteddata)
    },
    /**
     * Fetches data for the current page (server-side pagination)
     * @param {number} d - The page number to fetch (1-based)
     */
    async getData(d = this.page, forceRefresh = false) {
      this.loading = true;
      const safePage = Math.max(1, Number(d) || 1);
      this.page = safePage;
      this.previousFilter.page = safePage;
      this.previousFilter.limit = this.pageSize;
      this.$emit('loading', true);
      let filter = JSON.parse(JSON.stringify(this.previousFilter));
      const serverPage = Math.max(0, (filter.page || 1) - 1);
      filter.page = serverPage;
      filter.limit = this.pageSize;
      // Adjust date range filters to be inclusive
      if (this.previousFilter?.submitdate?.end) {
        if (filter["submitdate"] && filter["submitdate"].end !== undefined) {
          let endDate = new Date(filter["submitdate"].end);
          endDate.setDate(endDate.getDate() + 1);
          let updatedEndDate = endDate.toISOString().split('T')[0];
          filter["submitdate"].end = updatedEndDate;
        }
      }
      if (this.previousFilter?.approvedate?.end) {
        if (filter["approvedate"] && filter["approvedate"].end !== undefined) {
          let endDate = new Date(filter["approvedate"].end);
          endDate.setDate(endDate.getDate() + 1);
          let updatedEndDate = endDate.toISOString().split('T')[0];
          filter["approvedate"].end = updatedEndDate;
        }
      }
      try {
        const result = await this.fetchApprovalsListWithCounts({ filter, axiosInstance: this.axios, forceRefresh });
        if (result && result.status === "success") {
          const data = result.data || [];
          const meta = result.meta || {};
          
          this.formatteddata = [...this.formatData(data)];
          this.meta = meta;
          
          // Update counts from combined API response
          this.updateCountsFromMeta(meta);
          
          // Set totalItems based on current filter state using counts from combined response
          if (this.activeStageFilter !== null && this.activeStageFilter !== undefined) {
            // Stage filter is active, use the specific count
            let stageTotal = 0;
            switch(this.activeStageFilter) {
              case 0:
              case "Open":
                stageTotal = this.dataStatusCount.open;
                break;
              case 1:
              case "Approved":
                stageTotal = this.dataStatusCount.approved;
                break;
              case -1:
              case "Rejected":
                stageTotal = this.dataStatusCount.rejected;
                break;
              case 2:
              case "In Progress":
                stageTotal = this.dataStatusCount.inProgress;
                break;
              case 3:
              case "Failed":
                stageTotal = this.dataStatusCount.retry;
                break;
            }
            this.totalItems = stageTotal;
          } else {
            // No stage filter, use global total from the counts
            const rootTotalCount = meta.totalCount || 0;
            this.totalItems = rootTotalCount;
            this.globalTotalItems = rootTotalCount;
          }
          
          this.prepareFilterOptions(this.filterData);
          
        } else {
          console.error('[ApprovalsList] API returned non-success status:', result);
          this.formatteddata = [];
          this.totalItems = 0;
          throw new Error("No requests found");
        }
      } catch (err) {
        console.error('[ApprovalsList] getData error:', err);
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        this.formatteddata = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
        this.$emit('loading', false);
      }
    },

    /**
     * Refreshes the data and resets pagination to first page if reload is requested.
     */
    async getRefreshData(d) {
      if (d.reload === true) {
        this.formatteddata = [];
        this.page = 1;
        this.totalItems = 0;
        this.previousFilter = { page: 1, limit: this.pageSize };
        
        // Single API call fetches both list and counts
        await this.getData(1, true);
      }
    },

    // Deprecated: Use handlePaginationPageChange instead
    loadNextPage(d) {
      this.page = d?.page || 1;
      this.getData(this.page);
    },
    /**
     * Applies filters and fetches data for the first page (or specified page)
     * @param {Object} filter - The filter object
     */
    async getFilterData(filter = {}) {
      
      // Check if stage filter is being applied or cleared
      if (filter?.filter?.stage && filter.filter.stage.length > 0) {
        this.activeStageFilter = filter.filter.stage[0]._id;
      } 
      // filter?.filter?.stage check removed to allow merging with activeStageFilter (Card selection)
      // if the filter component doesn't explicitly have a stage selection.

      // Always reset page to 1 on filter
      let formatFilter = {};
      
       // Check if this is a reset operation (empty filter or specific reset signal)
      if (!filter.filter || Object.keys(filter.filter).length === 0) {
          this.activeStageFilter = null;
      }

      Object.keys(filter?.filter || {}).forEach(key => {
        // Find matching option by key OR value (to handle potential misalignments from lb-filter component)
        let dataKey = this.filterOptionsData.find((item) => item.key === key || item.value === key);
        if (!dataKey) return;
        
        const targetKey = dataKey.key;

        // Initialize container based on type
        if (dataKey.type === "daterange") {
          formatFilter[targetKey] = {};
        } else {
          formatFilter[targetKey] = [];
        }

        // Handle value processing
        const inputValues = filter?.filter?.[key];
        // Ensure we handle both array and non-array inputs safely
        const values = Array.isArray(inputValues) ? inputValues : (inputValues ? [inputValues] : []);

        values.forEach((item) => {
          if (dataKey.type === "daterange") {
            // Capture date range object. Prioritize _id if it exists, otherwise use item directly
            if (item) {
              formatFilter[targetKey] = item._id || item;
            }
          } else {
             if (item && item._id) {
               formatFilter[targetKey].push(item._id);
             }
          }
        });

        // Cleanup empty entries
        if (dataKey.type === "daterange") {
           // Delete if empty object
           if (Object.keys(formatFilter[targetKey]).length === 0) {
             delete formatFilter[targetKey];
           }
        } else {
           // Delete if empty array
           if (formatFilter[targetKey].length === 0) {
             delete formatFilter[targetKey];
           }
        }
      });

      // Merge active stage filter from Card if not present in the new filter payload
      if (!formatFilter.stage && this.activeStageFilter !== null && this.activeStageFilter !== undefined) {
        formatFilter.stage = [this.activeStageFilter];
      }

      this.page = 1;
      formatFilter.page = 1;
      formatFilter.limit = this.pageSize;
      this.previousFilter = JSON.parse(JSON.stringify(formatFilter));
      this.formatteddata = [];
      this.totalItems = 0;
      
      // Single API call fetches both list and counts
      await this.getData(1, true);
    },
    generateFile(filter) {
      this.isFileGenarating = true
      let formatFilter = {type:[],approver:[],submitter:[],stage:[],"submitdate": [], "approvedate": []}

      Object.keys(filter?.filter || {}).forEach(key => {
        if(['limit','page'].indexOf(key) === -1){
          let dataKey = this.filterOptionsData.find((item)=> item.key === key);
          if(dataKey.type === "daterange"){
            formatFilter[key] ={};
          }
          else{
            formatFilter[key] =[];
          }
          (filter?.filter?.[key] || []).forEach((item) => {
            if(dataKey.type === "daterange"){
              formatFilter[key]= item._id || item;
            }
            else{
              formatFilter[key].push(item._id);
            }
          });
        }
      })
      // formatFilter.limit = 1000;
      // formatFilter.page = 0;
      this.axios.post("/v2/varianceanalysis/approvals/getlist", { filter: formatFilter}).then(dt => {
        if (dt.data.status === "success") {
          this.downloadExcel(dt.data?.data || [])
        } else throw new Error("Error reading data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
        this.isFileGenarating = false
      }).finally(() => {
        // this.loading = false;
        // this.$emit('loading', false);
        
      })
    },
    downloadExcel(data) {
      // Acquire Data (reference to the HTML table)
        let workbook = styledxlsx.utils.book_new();
        let primarycolor = "d8e8f0";
        // let heading2 = (this.tablecolors.heading.a || "").toString().replaceAll("#", "").toUpperCase();
        let body1 = "E3FFE3";
        // let body2 = "E8EEFF";
        let scolor = "84a3e1";
        // let ecolor = "d11b1b";
        let typecolors = {}
        typecolors["materialityrulevel"] = "e6ffcc";
        typecolors["bulkmaterialityrulevel"] = "e6ccff";
        typecolors["materialitygllevel"] = "b3e6ff";
        typecolors["bulkmaterialitygllevel"] = "ffccdc";
        typecolors["filematerialityrulevel"] = "ffd699";
        typecolors["filematerialitygllevel"] = "99ebff";
        typecolors["materialitysllevel"] = "d4f0c4";
        typecolors["bulkmaterialitysllevel"] = "c4d4f0";
        typecolors["filematerialitysllevel"] = "f0c4d4";
        typecolors["glorder"] = "df9fbf";
        typecolors["accesschange"] = "ecd8c6";
        typecolors["bulkaccesschange"] = "ffb3ec";
        typecolors["fileaccesschange"] = "f06197";
        typecolors["glselectionchange"] = "df9fbf";
        let filename = "Approvals";
        let dt = [
          [
            ""
          ],
          [
            {v: "Tool admin approver - Report", s: {font: {bold: true}, fill: {fgColor: {rgb: scolor}}}}
          ],
          [

          ],
          [
            {v: "Request Type", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
            {v: "Submitter", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
            {v: "Submitted On", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
            {v: "Resolved By", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
            {v: "Resolved On", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
            {v: "Status", s: {font: {bold: true}, fill: {fgColor: {rgb: primarycolor}}}},
          ]];
        for (const v of data) {
          let statusName = '';
          let statusColor = '80ffaa'
          if(v.stage === 0) {
            statusName = "Open";
            statusColor = '00ffff'
          }
          else if(v.stage === 1) {
            statusName = "Approved";
            statusColor = '80ffaa'
          }
          else if(v.stage === 2) {
            statusName = "In Progress";
            statusColor='ffcc00'
          } 
          else if(v.stage === -1) {
            statusName = "Rejected";
            statusColor = 'ff3300'
          }
          else if(v.stage === 3) {
            statusName = "Failed";
            statusColor = 'ff3300'
          }
          const resolvedByDetail = (v.stage === 3 && !v.approver_detail && v.updated_detail)
            ? v.updated_detail
            : v.approver_detail;
          const resolvedOnDate = (v.stage === 3 && !v.approvedate && v.updated_at)
            ? v.updated_at
            : v.approvedate;
          dt.push([
            {v: v?.typetext || "", s: {fill: {fgColor: {rgb: typecolors[v?.type]}}}},
            {v: v?.submitter_detail?.displayname || "", s: {fill: {fgColor: {rgb: body1}}}},
            {v: this.$nova.formatDateTime(v?.submitdate), s: {fill: {fgColor: {rgb: body1}}}},
            {v: resolvedByDetail?.displayname || "", s: {fill: {fgColor: {rgb: body1}}}},
            {v: this.$nova.formatDateTime(resolvedOnDate) || "", s: {fill: {fgColor: {rgb: body1}}}},
            {v: statusName || "", s: {fill: {fgColor: {rgb: statusColor}}}},
            
          ])
        }

        let worksheet = styledxlsx.utils.aoa_to_sheet(dt);

        styledxlsx.utils.book_append_sheet(workbook, worksheet, "TOP SHEET");
  
        styledxlsx.writeFile(workbook, `${filename}.xlsx`);
        this.isFileGenarating = false
    },
    // getMetaData is no longer needed - counts are now fetched via the combined API in getData()
    async handleCardFilter(stageId) {
      this.activeStageFilter = stageId; // Store the active filter
      
      // We manually update previousFilter instead of calling getFilterData to avoid wiping other filters
      // For In Progress (2), we also include string variants to ensure we catch all items
      if (stageId === 2) {
        this.previousFilter.stage = [2];
      } else {
        this.previousFilter.stage = [stageId];
      }
      
      this.previousFilter.page = 1;
      this.page = 1;
      this.formatteddata = [];
      this.totalItems = 0;
      
      // Single API call fetches both list and counts
      await this.getData(1, true);
    },
    /**
     * Updates the status counts from the combined API response meta
     * @param {Object} meta - The meta object from the combined API response
     */
    updateCountsFromMeta(meta) {
      this.dataStatusCount = {
        open: meta?.pending || 0,
        approved: meta?.approved || 0,
        rejected: meta?.rejected || 0,
        inProgress: meta?.inProgress || meta?.inprogress || 0,
        retry: meta?.failed || meta?.retry || 0
      };
    },
  },
  watch: {
    filterData: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.prepareFilterOptions(newValue);
        }
      }
    }
  },
  computed: {
    /** 
     * Returns total pages from meta data for server-side pagination
     */
    totalPages() {
      // First check if backend provides direct total_pages
      const directTotal = Number(this.meta?.total_pages
        ?? this.meta?.totalPages
        ?? this.meta?.total_page
        ?? this.meta?.totalpages);
      if (directTotal && directTotal > 0) {
        return directTotal;
      }
      
      // Calculate from totalItems
      const limit = Number(this.meta?.limit ?? this.pageSize) || this.pageSize;
      // Use totalItems which should already be set from list API
      const totalCount = Number(this.totalItems ?? 0);
      
      
      const computedTotal = limit > 0 ? Math.ceil(totalCount / limit) : 0;
      const result = Math.max(computedTotal, 1); // Always show at least 1 page if component is visible
      
      return result;
    },
    // dynamicMenu(){
    //    return this.$store.getters
    // }
  },

}
</script>

<style scoped>
.bg-grey
{
  background-color: rgb(236 236 236);
}
.selected-months {
  margin-top: 0px;
}
.selected-months ul {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  padding: 0;
  margin: 0;
  list-style-type: none; /* Remove default list styling */
}
.month-item {
  display: flex;
  align-items: center;
  margin: 2px 4px; /* Spacing around items */
  padding: 2px 4px;
  background-color: #ecf4f5; /* Background color for items */
  border-radius: 4px;
  font-size: 0.9em;
}
</style>
